import * as React from 'react';
import { SoldoutNotification } from '../../components/SoldoutNotification/SoldoutNotification';
import { getText } from './getText';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { getBuilders, getNewbuildingId } from '../../selectors/newbuilding';
import { getSoldoutNotificationInt } from '../../utils/businessLogic/getSoldoutNotificationInt';

export const SoldoutNotificationContainer = () => {
  const [isOpen, setOpen] = React.useState(false);
  const [quantity, setQuantity] = React.useState(5);
  const id = useSelector(getNewbuildingId);

  const close = React.useCallback(() => setOpen(false), []);
  const open = React.useCallback(() => setOpen(true), []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setQuantity(getSoldoutNotificationInt(id));
      open();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const fromDevelopersPropsCount = useSelector(
    (state: IApplicationState) => state.newbuilding.fromDevelopersPropsCount,
  );
  const builders = useSelector(getBuilders);
  const builderWithPhones = builders.find(builder => builder.phone && builder.phone.number);

  if (fromDevelopersPropsCount === 0 || !builderWithPhones) {
    return null;
  }

  return <SoldoutNotification isOpen={isOpen} close={close} open={open} text={getText({ quantity })} />;
};
